var isSearchBarOpen = false;
var toggleSearchCounts = 0;

function toggleLoader() {
  $("body").toggleClass('loading');
}

function toggleSearch(direction) {
    if (direction === 'down') {
      $('.search-mb a.icon-search').css('visibility', 'visible');
    } else {
      $('.search-mb a.icon-search').css('visibility', 'hidden');
    }
  
  	isSearchBarOpen = !isSearchBarOpen;
}

function toggleSidebar() {
  $("#sidebar-cart-icon").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

  	$("html").addClass('cart-show');
  });
  
  $("#page-body").click(function () {
    if ($("html").hasClass('cart-show')) {
      $("html").removeClass('cart-show');
    }
  });
  
  // click event when clicking close icon in cart sidebar
  $("#close-cart-sidebar").click(function () {
    $('html').removeClass('cart-show')
  })

}

$(document).ready(function () {
  
  	toggleSidebar();
  
  	//sticky header setting
    if ($('.wrapper-header-bt').length > 0) {
		var stickyHeader = new Waypoint.Sticky({
          element: $('.wrapper-header-bt')[0]
        });
    }
	
  
  	if ($('#shopify-section-navigation').length > 0) {
      var inview2 = new Waypoint.Inview({
        element: $('#shopify-section-navigation')[0],
        entered: function(direction) {
          toggleSearch(direction);
        },
        exit: function(direction) {
          toggleSearch(direction);
        }
      });
    }
  
  	//  Vertical slider in 
  	jQuery("#gallery-image").length && jQuery('#gallery-image').bxSlider({
      mode: 'vertical',
      slideWidth: 100,
      minSlides: 6,
      nextText: '<i class="fa fa-angle-down" title="Next"></i>',
      prevText: '<i class="fa fa-angle-up" title="Previous"></i>',
      hideControlOnEnd: true,
      infiniteLoop: false,
      pager: false,
      slideMargin: 10
    });

    jQuery("#gallery-image-wig").length && jQuery('#gallery-image-wig').bxSlider({
      mode: 'horizontal',
      slideWidth: 67,
      // shrinkItems: true,
      // responsive: true,
      minSlides: 6,
      // nextText: '<i class="fa fa-angle-down" title="Next"></i>',
      // prevText: '<i class="fa fa-angle-up" title="Previous"></i>',
      hideControlOnEnd: true,
      infiniteLoop: true
      // pager: false,
      // slideMargin: 10
    });
  
});